import { HttpClient } from "../core/request"

// ------------------------------------
// Constants
// ------------------------------------
export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const CHANGE_VISIBLE_LEFT_SIDEBAR = 'CHANGE_VISIBLE_LEFT_SIDEBAR';

// ------------------------------------
// Actions
// ------------------------------------
export function changeSearch (text = '', city = '', region = 0) {
  return {
    type    : CHANGE_SEARCH,
    payload : {
        text: text ? text : '',
        city: city ? city : '',
        region: region ? region : 0
    }
  }
};

export const cityAutocomplete = (city) => {
    return (dispatch, getState) => {
        return HttpClient().get('address/find/' + city);
    }
};

export const phraseAutocomplete = (phrase, city) => {
  return (dispatch, getState) => {
      if (city) {
        return HttpClient().get(`prepaid_deals?published=true&q=${phrase}&city=${city}`);
      } else {
        return HttpClient().get(`prepaid_deals?published=true&q=${phrase}`);
      }
      
  }
};

export function leftSidebarVisible (show) {
    return {
        type    : CHANGE_VISIBLE_LEFT_SIDEBAR,
        payload : show
    }
};

export const getFilterString = (ItemsList, selectedItems) => {
  let searchParamsLabels = [];
  for (let item of ItemsList) {
    if (selectedItems.indexOf(String(item.id)) > -1) {
      searchParamsLabels.push(item.name);
    }
  }

  return searchParamsLabels.join(', ')
}

// ------------------------------------
// Reducer
// ------------------------------------
const init = {
    text: '',
    city: '',
    region: 0
};
export function searchTextReducer (state = init, action) {
    return action.type === CHANGE_SEARCH
        ? action.payload
        : state
}

export function leftSidebarReducer (state = true, action) {
    return action.type === CHANGE_VISIBLE_LEFT_SIDEBAR
        ? action.payload
        : state
}



// WEBPACK FOOTER //
// ./src/store/search.js